(function (root) {
  'use strict';
  function recommendSize(value, unit, sizes) {
    const n = Number(value), inches = unit === 'cm' ? n / 2.54 : n;
    if (!Number.isFinite(inches) || inches < 15 || inches > 80) return { error: 'invalid' };
    const matches = sizes.filter(s => s.available).map(s => {
      const range = s.name.match(/\((\d+(?:\.\d+)?)\s*["″“”]?\s*[-–]\s*(\d+(?:\.\d+)?)\s*["″“”]?\)/);
      if (!range) return null;
      const low = Number(range[1]), high = Number(range[2]);
      return inches >= low - 0.001 && inches <= high + 0.001 ? { name: s.name, value: s.value, distance: Math.abs(inches - (low + high) / 2), margin: Math.min(inches - low, high - inches) } : null;
    }).filter(Boolean).sort((a,b) => a.distance - b.distance || b.margin - a.margin);
    return matches[0] || { error: 'none' };
  }
  root.MFBeltFit = { recommendSize };
  if (typeof module !== 'undefined' && module.exports) module.exports = root.MFBeltFit;
  if (typeof document === 'undefined' || customElements.get('mf-belt-fit-helper')) return;
  const confirmed = new Set();
  class MFBeltFitHelper extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return; this.dataset.ready = 'true';
      this.config = JSON.parse(this.querySelector('[data-mf-fit-config]').textContent);
      this.fieldset = this.closest('fieldset');
      if (this.dataset.explicit === 'true') confirmed.add(this.dataset.form);
      if (!confirmed.has(this.dataset.form)) this.fieldset?.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
      this.querySelector('[data-mf-fit-close]')?.addEventListener('click', () => {
        const panel = this.querySelector('details');
        panel.open = false;
        panel.querySelector('summary').focus({ preventScroll: true });
      });
      this.updateGuard();
      this.querySelector('[data-mf-check]').addEventListener('click', () => this.check());
      this.populateMeasurements();
      this.querySelector('[data-mf-unit]').addEventListener('change', () => {
        this.populateMeasurements();
        this.choice = null;
        this.querySelector('[data-mf-fit-select]').hidden = true;
        this.querySelector('[data-mf-fit-result]').textContent = '';
      });
      for (const selector of ['[data-mf-measure]', '[data-mf-unit]']) this.querySelector(selector).addEventListener('input', () => { this.choice = null; this.querySelector('[data-mf-fit-select]').hidden = true; this.querySelector('[data-mf-fit-result]').textContent = ''; });
      this.querySelector('[data-mf-fit-select]').addEventListener('click', () => {
        if (!this.choice) return;
        const radio = [...this.fieldset.querySelectorAll('input[type="radio"]')].find(input => input.value === String(this.choice.value));
        if (radio && !radio.disabled) { confirmed.add(this.dataset.form); radio.click(); this.updateGuard(); }
      });
      try { const saved = JSON.parse(localStorage.getItem('modifit_belt_selection_v1')); this.querySelector('[data-mf-resume]').hidden = !(saved?.expires > Date.now()); } catch (_) {}
    }
    populateMeasurements() {
      const field = this.querySelector('[data-mf-measure]');
      const centimetres = this.querySelector('[data-mf-unit]').value === 'cm';
      const placeholder = field.options[0].textContent;
      field.replaceChildren(new Option(placeholder, ''));
      const start = centimetres ? 39 : 30, end = centimetres ? 203 : 160;
      for (let i = start; i <= end; i++) {
        const value = centimetres ? i : i / 2;
        field.add(new Option(value + (centimetres ? ' cm' : '″'), String(value)));
      }
      field.value = '';
    }
    check() {
      const match = recommendSize(this.querySelector('[data-mf-measure]').value, this.querySelector('[data-mf-unit]').value, this.config.sizes);
      this.choice = match.error ? null : match;
      this.querySelector('[data-mf-fit-result]').textContent = match.error ? this.config[match.error] : this.config.match + ' ' + match.name;
      this.querySelector('[data-mf-fit-select]').hidden = !this.choice;
    }
    updateGuard() { this.querySelector('[data-mf-size-guard]').hidden = confirmed.has(this.dataset.form); }
    requireChoice(event) {
      if (confirmed.has(this.dataset.form)) return false;
      event.preventDefault(); event.stopImmediatePropagation();
      const status = this.querySelector('[data-mf-size-guard]'); status.hidden = false; status.dataset.error = 'true';
      this.fieldset.scrollIntoView({ behavior: 'auto', block: 'center' });
      const radio = this.fieldset.querySelector('input[type="radio"]'); radio?.focus({ preventScroll: true });
      return true;
    }
  }
  customElements.define('mf-belt-fit-helper', MFBeltFitHelper);
  document.addEventListener('click', event => {
    const input = event.target.closest('input[type="radio"][data-option-position]');
    if (input) {
      const helper = input.closest('fieldset')?.querySelector('mf-belt-fit-helper');
      if (helper && !input.disabled) { confirmed.add(helper.dataset.form); helper.updateGuard(); }
    }
    const button = event.target.closest('button[type="submit"], input[type="submit"], .shopify-payment-button');
    if (!button) return;
    const form = button.form || button.closest('form'); if (!form) return;
    document.querySelectorAll('mf-belt-fit-helper').forEach(helper => { if (helper.dataset.form === form.getAttribute('id')) helper.requireChoice(event); });
  }, true);
  document.addEventListener('submit', event => {
    document.querySelectorAll('mf-belt-fit-helper').forEach(helper => { if (helper.dataset.form === event.target.getAttribute('id')) helper.requireChoice(event); });
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);
